import { environment } from '@coin/shared/core/util-environments';
import { TranslateModuleConfig } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppEnvironment } from './enums/app-environments.enum';

export class CustomTranslationLoader {
  static createConfig(app: AppEnvironment): TranslateModuleConfig {
    return {
      loader: provideTranslateHttpLoader({
        prefix: `${environment.cmsContentProdBucketCloudfront}translations/${app}/`,
        suffix: '.json'
      })
    };
  }
}
